import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Mountain, Loader2, MailCheck, ArrowLeft } from 'lucide-react';

// Pagina PUBBLICA di richiesta recupero password (nessun login richiesto).
// Risposta sempre generica (anti-enumeration): non rivela se l'email esiste.
export default function ForgotPassword() {
  const [params] = useSearchParams();
  const isCustomer = params.get('area') === 'cliente';
  const loginPath = isCustomer ? '/cliente/accedi' : '/login';
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email: email.trim().toLowerCase() });
    } catch {
      /* risposta generica anche in caso di errore: non esporre nulla */
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="w-full max-w-md">
        <div className="mb-8 flex items-center gap-2.5">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary text-primary-foreground"><Mountain className="h-5 w-5" /></div>
          <div><p className="font-display text-lg font-bold">Sila Experiences</p><p className="text-xs text-muted-foreground">Recupero password</p></div>
        </div>

        {!sent ? (
          <>
            <h1 className="font-display text-2xl font-bold tracking-tight">Password dimenticata?</h1>
            <p className="mt-1 text-sm text-muted-foreground">Inserisci la tua email: se è associata a un account, riceverai un link per reimpostare la password (valido 1 ora).</p>
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-password-form">
              <div className="space-y-2"><Label htmlFor="email">Email</Label><Input id="email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@email.it" data-testid="forgot-password-email-input" /></div>
              <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-password-submit-button">{loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Invia il link di recupero</Button>
            </form>
          </>
        ) : (
          <div data-testid="forgot-password-sent">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-accent"><MailCheck className="h-6 w-6 text-primary" /></div>
            <h1 className="font-display text-2xl font-bold tracking-tight">Controlla la tua email</h1>
            <p className="mt-2 text-sm text-muted-foreground">Se l'indirizzo <span className="font-medium text-foreground">{email}</span> è associato a un account, ti abbiamo inviato un link per reimpostare la password. Controlla anche la cartella spam.</p>
          </div>
        )}

        <p className="mt-6 text-sm text-muted-foreground">
          <Link to={loginPath} className="inline-flex items-center font-medium text-primary hover:underline" data-testid="forgot-password-back-link"><ArrowLeft className="mr-1.5 h-4 w-4" />Torna all'accesso</Link>
        </p>
      </div>
    </div>
  );
}
